import React from 'react';
import { useQueryClient } from '@tanstack/react-query';
import toJsonKey from '../utils/toJsonKey';
import { PayloadStates } from '@lore/utils';

export function useRemoveQueries() {
  const queryClient = useQueryClient();

  return function removeQueries(key, params) {
    const [model, method] = key.split('.');

    const jsonKey = toJsonKey(params);

    if (
      method === 'first' ||
      method === 'find'
    ) {
      return queryClient.removeQueries({
        queryKey: params ?
          [model, method, jsonKey] :
          [key],
        exact: true
      });
    }

    if (method === 'byId') {
      if (!params.id) {
        throw new Error('missing params.id');
      }

      return queryClient.removeQueries({
        queryKey: [model, method, params.id],
        exact: true
      });
    }

    throw new Error(`Invalid method: ${key}`);
  }
}
